import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconChevronDown from '@spothero/icons/chevron-down';
import IconChevronUp from '@spothero/icons/chevron-up';
import TextButton from '@spothero/ui/text-button';
import Price from 'common/price/Price';
import PriceBreakdownItem from './PriceBreakdownItem';

const PriceBreakdownItemRollup = ({
    className,
    item: {price, short_description: shortDescription, sub_items: subItems},
    currencyType,
}) => {
    const classes = classNames('PriceBreakdownItemRollup', className);
    const [showSubItems, setShowSubItems] = useState(false);
    const toggleSubItems = () => setShowSubItems(show => !show);

    return (
        <div className={classes}>
            <div className="PriceBreakdownItemRollup-line-item">
                <span className="PriceBreakdownItemRollup-label">
                    <TextButton onClick={toggleSubItems} iconPosition="right">
                        {shortDescription}
                        {showSubItems ? <IconChevronUp /> : <IconChevronDown />}
                    </TextButton>
                </span>
                <Price amount={price} currencyType={currencyType} showCents />
            </div>
            {showSubItems && (
                <div className="PriceBreakdownItemRollup-sub-items">
                    {subItems.map((subItem, i) => {
                        return (
                            <PriceBreakdownItem
                                key={i}
                                className="PriceBreakdownItem-in-rollup"
                                item={subItem}
                                currencyType={currencyType}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};

PriceBreakdownItemRollup.propTypes = {
    className: PropTypes.string,
    item: PropTypes.shape({
        price: PropTypes.number.isRequired,
        short_description: PropTypes.string.isRequired, // eslint-disable-line camelcase
        sub_items: PropTypes.array.isRequired, // eslint-disable-line camelcase
    }).isRequired,
    currencyType: PropTypes.string.isRequired,
};

export default PriceBreakdownItemRollup;
